export default __webpack_public_path__ + "14a63f36a6d768015c4f16eecf02c2a1.woff";